import Button from '@material-ui/core/Button';
import { withSnackbar } from 'notistack';
import React, { Component } from 'react';
import { handleChangeEvent, handlePost, handleDateChangeEvent } from '../../../../utils/AxiosUtil';
import * as enums from '../../../../utils/EnumMapping';
import * as util from '../../../../utils/Util';
import ErrorAwareAmountField from '../../../common/inputfields/ErrorAwareAmountField';
import ErrorAwareDatePicker from '../../../common/inputfields/ErrorAwareDatePicker';
import ErrorAwareTextField from '../../../common/inputfields/ErrorAwareTextField';
import ErrorAwareSelectField from '../../../common/inputfields/ErrorAwareSelectField';
import NewAgainField from '../../../common/inputfields/NewAgainField';
import PaymentMethodFormControl from '../../../common/inputfields/PaymentMethodFormControl';
import ErrorAwareNumberField from '../../../common/inputfields/ErrorAwareNumberField';
// import { toDate } from 'date-fns';

class NewEmployee extends Component {

    state = {
        newAgain: false,
        selectedPaymentMethod: enums.outPaymentMethods[0],
        grossSalary: '',
        netSalary: '',
        name: '',
        mothersName: '',
        birthPlace: '',
        birthDate: new Date(),
        insuranceNumber: '',
        taxNumber: '',
        address: '',
        highestSchool: enums.highestSchool[0],
        qualification: '',
        wantsVacationAfterKids: enums.trueFalse[2],
        wantsFamilyDiscount: enums.trueFalse[2],
        wantsMarriageDiscount: enums.trueFalse[2],
        eligibleForDisabilityDiscount: enums.trueFalse[2],
        startDate: new Date(),
        definiteContractEnd: null,
        workingHours: 8,
        haveExitPapersFromPreviousEmployment: enums.trueFalse[2],
        haveTbBook: enums.trueFalse[2],
        availableVacations: '',
        selectedEmployeeType: enums.employeeTypes[0],
        haveDriverLicense: enums.trueFalseHaving[2],
        errors: new Map(),
    }

    resetForm = () => {
        this.setState({
            newAgain: false,
            selectedPaymentMethod: enums.outPaymentMethods[0],
            grossSalary: '',
            netSalary: '',
            name: '',
            mothersName: '',
            birthPlace: '',
            birthDate: new Date(),
            insuranceNumber: '',
            taxNumber: '',
            address: '',
            highestSchool: enums.highestSchool[0],
            qualification: '',
            wantsVacationAfterKids: enums.trueFalse[2],
            wantsFamilyDiscount: enums.trueFalse[2],
            wantsMarriageDiscount: enums.trueFalse[2],
            eligibleForDisabilityDiscount: enums.trueFalse[2],
            startDate: new Date(),
            definiteContractEnd: null,
            workingHours: 8,
            haveExitPapersFromPreviousEmployment: enums.trueFalse[2],
            haveTbBook: enums.trueFalse[2],
            availableVacations: '',
            selectedEmployeeType: enums.employeeTypes[0],
            haveDriverLicense: enums.trueFalseHaving[2],
            errors: new Map(),
        })
    }
    handleSubmit = async (event) => {
        event.persist()
        event.preventDefault();

        const path = '/api/employee';
        const requestObject = {
            "paymentMethod": this.state.selectedPaymentMethod.value,
            "grossSalary": util.toNumber(this.state.grossSalary),
            "netSalary": util.toNumber(this.state.netSalary),
            "name": this.state.name,
            "mothersName": this.state.mothersName,
            "birthPlace": this.state.birthPlace,
            "birthDate": this.state.birthDate,
            "insuranceNumber": this.state.insuranceNumber,
            "taxNumber": this.state.taxNumber,
            "address": this.state.address,
            "highestSchool": this.state.highestSchool.value,
            "qualification": this.state.qualification,
            "wantsVacationAfterKids": this.state.wantsVacationAfterKids.value,
            "wantsFamilyDiscount": this.state.wantsFamilyDiscount.value,
            "wantsMarriageDiscount": this.state.wantsMarriageDiscount.value,
            "eligibleForDisabilityDiscount": this.state.eligibleForDisabilityDiscount.value,
            "startDate": this.state.startDate,
            "definiteContractEnd": this.state.definiteContractEnd ? new Date(this.state.definiteContractEnd) : null,
            "workingHours": this.state.workingHours,
            "haveExitPapersFromPreviousEmployment": this.state.haveExitPapersFromPreviousEmployment.value,
            "haveTbBook": this.state.haveTbBook.value,
            "availableVacations": this.state.availableVacations,
            "type": this.state.selectedEmployeeType.value,
            "haveDriverLicense": this.state.haveDriverLicense.value,
        };

        handlePost(path, requestObject, this);
    };

    render() {
        return (
            <form onSubmit={this.handleSubmit}>
                <div className='flex-form'>
                    <div className='input-group-3'>
                        <ErrorAwareSelectField
                            labelId="employee-type-label"
                            id="employee-type"
                            name="selectedEmployeeType"
                            label="Munkavállaló típusa"
                            errors={this.props.errors}
                            value={this.state.selectedEmployeeType}
                            onChange={e => handleChangeEvent(e, this)}
                            options={enums.employeeTypes}
                        />
                    </div>
                    <div className='input-group-3'>
                        <ErrorAwareTextField
                            required
                            name="name"
                            label="Név"
                            errors={this.state.errors}
                            value={this.state.name}
                            onChange={e => handleChangeEvent(e, this)} />
                    </div>
                    <div className='input-group-3'>
                        <ErrorAwareTextField
                            name="mothersName"
                            label="Anyja neve"
                            errors={this.state.errors}
                            value={this.state.mothersName}
                            onChange={e => handleChangeEvent(e, this)} />
                    </div>
                    <div className='input-group-3'>
                        <ErrorAwareTextField
                            name="birthPlace"
                            label="Születési hely"
                            errors={this.state.errors}
                            value={this.state.birthPlace}
                            onChange={e => handleChangeEvent(e, this)} />
                    </div>
                    <div className='input-group-3'>
                        <ErrorAwareDatePicker
                            name="birthDate"
                            label="Születési idő"
                            errors={this.state.errors}
                            value={this.state.birthDate}
                            onChange={e => handleDateChangeEvent(e, "birthDate", this)} />
                    </div>
                    <div className='input-group-3'>
                        <ErrorAwareTextField
                            name="insuranceNumber"
                            label="TAJ szám"
                            errors={this.state.errors}
                            value={this.state.insuranceNumber}
                            onChange={e => handleChangeEvent(e, this)} />
                    </div>
                    <div className='input-group-3'>
                        <ErrorAwareTextField
                            name="taxNumber"
                            label="Adószám"
                            errors={this.state.errors}
                            value={this.state.taxNumber}
                            onChange={e => handleChangeEvent(e, this)} />
                    </div>
                    {this.state.selectedEmployeeType.value === "FULL_TIME"
                        && <>
                            <div className='input-group-3'>
                                <ErrorAwareAmountField
                                    required
                                    id="grossSalary"
                                    name="grossSalary"
                                    label="Bruttó fizetés"
                                    errors={this.state.errors}
                                    value={this.state.grossSalary}
                                    onChange={e => handleChangeEvent(e, this)} />
                            </div>
                            <div className='input-group-3'>
                                <ErrorAwareAmountField
                                    required
                                    id="netSalary"
                                    name="netSalary"
                                    label="Nettó fizetés"
                                    errors={this.state.errors}
                                    value={this.state.netSalary}
                                    onChange={e => handleChangeEvent(e, this)} />
                            </div>
                            <div className='input-group-3'>
                                <PaymentMethodFormControl
                                    options={enums.outPaymentMethods}
                                    value={this.state.selectedPaymentMethod}
                                    onChange={e => handleChangeEvent(e, this)} />
                            </div>
                        </>}
                    <div className='input-group-3'>
                        <ErrorAwareTextField
                            name="address"
                            label="Cím"
                            errors={this.state.errors}
                            value={this.state.address}
                            onChange={e => handleChangeEvent(e, this)} />
                    </div>
                    <div className='input-group-3'>
                        <ErrorAwareSelectField
                            labelId="highest-school-label"
                            id="highest-school"
                            name="highestSchool"
                            label="Legmagasabb iskolai végzettség"
                            errors={this.state.errors}
                            value={this.state.highestSchool}
                            onChange={e => handleChangeEvent(e, this)}
                            options={enums.highestSchool} />
                    </div>
                    <div className='input-group-3'>
                        <ErrorAwareTextField
                            name="qualification"
                            label="Szakképzettség"
                            errors={this.state.errors}
                            value={this.state.qualification}
                            onChange={e => handleChangeEvent(e, this)} />
                    </div>
                    {this.state.selectedEmployeeType.value === "FULL_TIME"
                        && <>
                            <div className='input-group-3'>
                                <ErrorAwareDatePicker
                                    required
                                    name="startDate"
                                    label="Jogviszony kezdete"
                                    errors={this.state.errors}
                                    value={this.state.startDate}
                                    onChange={e => handleDateChangeEvent(e, "startDate", this)} />
                            </div>
                            <div className='input-group-3'>
                                <ErrorAwareDatePicker
                                    name="definiteContractEnd"
                                    label="Határozott idő lejárta"
                                    errors={this.state.errors}
                                    value={this.state.definiteContractEnd}
                                    onChange={e => handleDateChangeEvent(e, "definiteContractEnd", this)} />
                            </div>
                            <div className='input-group-3'>
                                <ErrorAwareNumberField
                                    id="workingHours"
                                    name="workingHours"
                                    label="Napi munkaidő (óra)"
                                    errors={this.state.errors}
                                    value={this.state.workingHours}
                                    onChange={e => handleChangeEvent(e, this)} />
                            </div>
                            <div className='input-group-3'>
                                <ErrorAwareNumberField
                                    id="availableVacations"
                                    name="availableVacations"
                                    label="Szabadság napok"
                                    errors={this.state.errors}
                                    value={this.state.availableVacations}
                                    onChange={e => handleChangeEvent(e, this)} />
                            </div>
                            <div className='input-group-3'>
                                <ErrorAwareSelectField
                                    labelId="vac-after-kids-label"
                                    id="vac-after-kids"
                                    name="wantsVacationAfterKids"
                                    label="Igényt tart-e gyerekek után járó pótszabadságra?"
                                    errors={this.state.errors}
                                    value={this.state.wantsVacationAfterKids}
                                    onChange={e => handleChangeEvent(e, this)}
                                    options={enums.trueFalse} />
                            </div>
                            <div className='input-group-3'>
                                <ErrorAwareSelectField
                                    labelId="family-discount"
                                    id="family-discount"
                                    name="wantsFamilyDiscount"
                                    label="Igényt tart-e családi kedvezményre?"
                                    errors={this.state.errors}
                                    value={this.state.wantsFamilyDiscount}
                                    onChange={e => handleChangeEvent(e, this)}
                                    options={enums.trueFalse} />
                            </div>
                            <div className='input-group-3'>
                                <ErrorAwareSelectField
                                    labelId="marriage-discount-label"
                                    id="marriage-discount"
                                    name="wantsMarriageDiscount"
                                    label="Igényt tart-e első házasok kedvezményére?"
                                    errors={this.state.errors}
                                    value={this.state.wantsMarriageDiscount}
                                    onChange={e => handleChangeEvent(e, this)}
                                    options={enums.trueFalse} />
                            </div>
                            <div className='input-group-3'>
                                <ErrorAwareSelectField
                                    labelId="disability-discount-label"
                                    id="disability-discount"
                                    name="eligibleForDisabilityDiscount"
                                    label="Jogosult-e fogyatékos kedvezményre?"
                                    errors={this.state.errors}
                                    value={this.state.eligibleForDisabilityDiscount}
                                    onChange={e => handleChangeEvent(e, this)}
                                    options={enums.trueFalse} />
                            </div>
                            <div className='input-group-3'>
                                <ErrorAwareSelectField
                                    labelId="exit-papers-label"
                                    id="exit-papers"
                                    name="haveExitPapersFromPreviousEmployment"
                                    label="Adott-e le előző munkaviszony leszámoló papírjait?"
                                    errors={this.state.errors}
                                    value={this.state.haveExitPapersFromPreviousEmployment}
                                    onChange={e => handleChangeEvent(e, this)}
                                    options={enums.trueFalse} />
                            </div>
                            <div className='input-group-3'>
                                <ErrorAwareSelectField
                                    labelId="have-tb-book-label"
                                    id="have-tb-book"
                                    name="haveTbBook"
                                    label="Adott-e le tb kiskönyvet?"
                                    errors={this.state.errors}
                                    value={this.state.haveTbBook}
                                    onChange={e => handleChangeEvent(e, this)}
                                    options={enums.trueFalse} />
                            </div>
                        </>}
                    <div className='input-group-3'>
                        <ErrorAwareSelectField
                            labelId="have-driver-license-label"
                            id="have-driver-license"
                            name="haveDriverLicense"
                            label="Van-e jogosítványa?"
                            errors={this.state.errors}
                            value={this.state.haveDriverLicense}
                            onChange={e => handleChangeEvent(e, this)}
                            options={enums.trueFalseHaving} />
                    </div>
                </div>
                <div className="form-actions">
                    <NewAgainField
                        checked={this.state.newAgain}
                        onChange={e => this.setState({ newAgain: e.target.checked })} />
                    <Button className="btn-submit" variant="contained" color="primary" type="submit">
                        Hozzáadás
                    </Button>
                </div>
            </form>
        )
    }
}

export default withSnackbar(NewEmployee);
